import React from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row, Spinner, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "../services/apiMethods";

export default function Invoices() {
  const Navigate = useNavigate();
  const { data: invoiceData, refetch, isLoading } = useQuery({
    queryKey: ["invoice"], // Ensure re-fetch on changes
    queryFn: () => getRequest(`/lead/subscription/invoice`),

  });
  const handleDownload = (url) => {
    if (!url) {
      alert("Download link not available");
      return;
    }
    // Open the URL in a new tab
    window.open(url, "_blank");
  };


  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => Navigate("/settings")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Account
            </h3>
            <Row>
              <Col lg={8}>
                <div className="my-profile-card-contain">
                  <div className="my-profile-title">
                    <h4>Invoices</h4>
                    <p>All of your purchases can be found here</p>
                  </div>
                  <div className="my-profile-box-contain">
                    {isLoading ?
                      <>
                              <div className="pre-pending-card" style={{ height: 500 }}>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: 100 }} >
                                  <Spinner animation="border" variant="primary" />
                                </div>
                              </div>
                      
                      </>
                      :
                      <div className="my-profile-box-form p-0 vh-60">
                        <Table responsive="sm" id="my-table">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Type</th>
                              <th>Amount</th>
                              <th></th>
                            </tr>
                          </thead>
                          {Array.isArray(invoiceData?.data) &&
                            invoiceData?.data.length > 0 && (
                              <>
                                <tbody>
                                  {invoiceData?.data.map((val, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>{val?.date}</td>
                                        <td>{val?.type}</td>
                                        <td>{val?.amount}</td>
                                        <td>
                                          <div className="downld-btn">
                                            <button
                                              onClick={() =>
                                                handleDownload(val?.downloadUrl)
                                              }
                                            >
                                              Download Invoice
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </>
                            )}
                        </Table>
                        {!Array.isArray(invoiceData?.data) && (
                          <h6 className="no-date-found">No Data Found</h6>
                        )}
                      </div>}
                  </div>
                </div>
              </Col>
              <Col lg={4}></Col>
            </Row>
          </div>
        </Container>
      </Layout>
    </>
  );
}
